import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { PermissionLogic } from 'common/permissions/PermissionLogic';
import { IProcedure, ProcedureDossierType } from 'common/schema/Procedure';
import { IRequest } from 'common/schema/request/Request';
import React from 'react';
import { Link } from 'react-router-dom';

export interface IRequestTableAdminProps {
  request: IRequest;
}

export function RequestTableAdminActions(props: IRequestTableAdminProps) {
  const currentUser = useCurrentUser();
  const canRank = PermissionLogic.has(currentUser, 'request.rank');
  const hasDossier = props.request.dossierId;
  return (
    <Link
      to={
        hasDossier
          ? `/admin/procedures/${props.request.procedureId}/requests/${props.request.id}`
          : `/admin/procedures/${props.request.procedureId}/requests/${props.request.id}/document`
      }
    >
      <Button
        size="small"
        type={canRank ? 'primary' : 'default'}
        icon={canRank ? <EditOutlined /> : <EyeOutlined />}
      >
        {canRank ? 'Valuta' : 'Visualizza'}
      </Button>
    </Link>
  );
}
